import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './authContext';
import ReactProfilerBoundary from './frontend-performance/ReactProfilerBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ReactProfilerBoundary>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ReactProfilerBoundary>
);
